module.exports = __webpack_public_path__ + "img/Parking 2.svg";